module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-voxi-04@2x.75da88a8.jpg";